import { Grid, useTheme, makeStyles, Paper, IconButton } from '@material-ui/core'
// import useMediaQuery from '@material-ui/core/useMediaQuery'
import { Typography } from '@material-ui/core'
import { EditFormHeaderCtrlPropsType, EditFormHeaderViewPropsType } from './editFormHeaderType'
// import useEditFormHeader from './useEditFormHeader'
// import moment from 'moment'
import { GetProjectResultType, ItemListType } from '../../../../services/web/types/responseWebServiceTypes'
import { statusColorConstant } from '../../../../constants/constants'
// import EditIcon from '@material-ui/icons/Edit'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../utilities/date'
import useTranslate from '../../../../i18n/useTranslate'
import constProjectStatus from '../../../../constants/projectStatus'
import useCheckPermission from '../../../../utilities/checkPermission'
import projectStatus from '../../../../constants/projectStatus'
import submittedStatus from '../../../../constants/submittedStatus'

const AdminEditView = (props: EditFormHeaderViewPropsType) => {
    const { projectData } = props
    const theme = useTheme()
    const classes = useStyles()
    const translate = useTranslate()
    // const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const checkPermission = useCheckPermission()
    const isResearcher = checkPermission.isUserResearcher()
    const checkStatusColor = (itm: GetProjectResultType) => {
        let projectStatusBackgroundColor = ''
        let statusTextColor = ''
        let submittedStatusColor = ''

        switch (itm.projectStatusInfo?.value) {
            case projectStatus.rejected:
                // code block ไม่อนุมัติ
                projectStatusBackgroundColor = statusColorConstant.statusReject.backgroundColor
                // statusTextColor = statusColorConstant.statusReject.textColor
                break
            case projectStatus.closed:
                // code block ปิดโครงการ
                projectStatusBackgroundColor = statusColorConstant.statusClose.backgroundColor
                // statusTextColor = statusColorConstant.statusClose.textColor
                break
            case projectStatus.notScope:
                // code block ไม่เข้าข่าย
                projectStatusBackgroundColor = statusColorConstant.noScope.backgroundColor
                // statusTextColor = statusColorConstant.noScope.textColor
                break
            case projectStatus.terminate:
                // code block ยุติโครงการ
                projectStatusBackgroundColor = statusColorConstant.terminate.backgroundColor
                // statusTextColor = statusColorConstant.terminate.textColor
                break
            case projectStatus.withdraw:
                // code block ถอนโครงการ
                projectStatusBackgroundColor = statusColorConstant.withdraw.backgroundColor
                // statusTextColor = statusColorConstant.withdraw.textColor
                break
            case projectStatus.processing:
                // กำลังดำเนินการ
                projectStatusBackgroundColor = statusColorConstant.status15.backgroundColor
                // statusTextColor = statusColorConstant.status15.textColor
                break
            case projectStatus.completed:
                // ดำเนินการเสร็จสิ้น
                projectStatusBackgroundColor = statusColorConstant.status8.backgroundColor
                // statusTextColor = statusColorConstant.status8.textColor
                break
            default:
                // statusId = null (ร่าง)
                projectStatusBackgroundColor = statusColorConstant.status1.backgroundColor
                // statusTextColor = statusColorConstant.status1.textColor

                break
        }

        switch (itm?.submittedStatusInfo?.value) {
            case statusColorConstant.status1.statusID:
                // code block
                submittedStatusColor = statusColorConstant.status1.backgroundColor
                statusTextColor = statusColorConstant.status1.textColor
                break

            case statusColorConstant.status2.statusID:
                // code block

                submittedStatusColor = statusColorConstant.status2.backgroundColor
                statusTextColor = statusColorConstant.status2.textColor

                break
            case statusColorConstant.status3.statusID:
                submittedStatusColor = statusColorConstant.status3.backgroundColor
                statusTextColor = statusColorConstant.status3.textColor

                break
            case statusColorConstant.status4.statusID:
                submittedStatusColor = statusColorConstant.status4.backgroundColor
                statusTextColor = statusColorConstant.status4.textColor

                break
            case statusColorConstant.status18.statusID:
                submittedStatusColor = statusColorConstant.status18.backgroundColor
                statusTextColor = statusColorConstant.status18.textColor

                break
            case statusColorConstant.status5.statusID:
                submittedStatusColor = statusColorConstant.status5.backgroundColor
                statusTextColor = statusColorConstant.status5.textColor

                break
            case statusColorConstant.status6.statusID:
                submittedStatusColor = statusColorConstant.status6.backgroundColor
                statusTextColor = statusColorConstant.status6.textColor

                break
            case statusColorConstant.status7.statusID:
                submittedStatusColor = statusColorConstant.status7.backgroundColor
                statusTextColor = statusColorConstant.status7.textColor

                break
            case statusColorConstant.status8.statusID:
                submittedStatusColor = statusColorConstant.status8.backgroundColor
                statusTextColor = statusColorConstant.status8.textColor

                break
            case statusColorConstant.status9.statusID:
                submittedStatusColor = statusColorConstant.status9.backgroundColor
                statusTextColor = statusColorConstant.status9.textColor

                break
            case statusColorConstant.status10.statusID:
                submittedStatusColor = statusColorConstant.status10.backgroundColor
                statusTextColor = statusColorConstant.status10.textColor

                break
            case statusColorConstant.status11.statusID:
                submittedStatusColor = statusColorConstant.status11.backgroundColor
                statusTextColor = statusColorConstant.status11.textColor

                break
            case statusColorConstant.status12.statusID:
                submittedStatusColor = statusColorConstant.status12.backgroundColor
                statusTextColor = statusColorConstant.status12.textColor
                break
            case statusColorConstant.status14.statusID:
                // code block
                submittedStatusColor = statusColorConstant.status14.backgroundColor
                statusTextColor = statusColorConstant.status14.textColor
                break
            case statusColorConstant.status17.statusID:
                // code block
                submittedStatusColor = statusColorConstant.status17.backgroundColor
                statusTextColor = statusColorConstant.status17.textColor
                break
            // case statusColorConstant.status15.statusID:
            //     // กำลังดำเนินการ
            //     submittedStatusColor = statusColorConstant.status15.backgroundColor
            //     statusTextColor = statusColorConstant.status15.textColor
            //     break
            case statusColorConstant.resultOfConsideration.statusID:
                // code block
                submittedStatusColor = statusColorConstant.resultOfConsideration.backgroundColor
                statusTextColor = statusColorConstant.resultOfConsideration.textColor
                break
            case statusColorConstant.noScope.statusID:
                // code block
                submittedStatusColor = statusColorConstant.noScope.backgroundColor
                statusTextColor = statusColorConstant.noScope.textColor
                break
            case statusColorConstant.terminate.statusID:
                // code block
                submittedStatusColor = statusColorConstant.terminate.backgroundColor
                statusTextColor = statusColorConstant.terminate.textColor
                break
            case statusColorConstant.withdraw.statusID:
                // code block
                submittedStatusColor = statusColorConstant.withdraw.backgroundColor
                statusTextColor = statusColorConstant.withdraw.textColor
                break
            case statusColorConstant.proceedingMemoMessage.statusID:
                // ดำเนินการทำใบบันทึกข้อความ
                submittedStatusColor = statusColorConstant.proceedingMemoMessage.backgroundColor
                statusTextColor = statusColorConstant.proceedingMemoMessage.textColor
                break
            case statusColorConstant.waitingEditProject.statusID:
                // รอแก้ไขโครงการ
                if (isResearcher) {
                    submittedStatusColor = statusColorConstant.waitingEditProject.researcher.backgroundColor
                    statusTextColor = statusColorConstant.waitingEditProject.researcher.textColor
                } else {
                    submittedStatusColor = statusColorConstant.waitingEditProject.backgroundColor
                    statusTextColor = statusColorConstant.waitingEditProject.textColor
                }
                submittedStatusColor = statusColorConstant.waitingEditProject.backgroundColor
                statusTextColor = statusColorConstant.waitingEditProject.textColor
                break
            default:
                // statusId = null (ร่าง)
                submittedStatusColor = statusColorConstant.status1.backgroundColor
                statusTextColor = statusColorConstant.status1.textColor

                break
        }

        return { submittedStatusColor, statusTextColor, projectStatusBackgroundColor }
    }

    const getDisplayResearcherName = (val: any) => {
        let displayResearcherName = ''
        if (translate.languageStore.currentLanguage === translate.languageKey.th) {
            displayResearcherName = val?.researcherFullname_th ?? '-'
            if (val?.researcherTypeInfo?.nameTH) {
                displayResearcherName += ` (${val?.researcherTypeInfo?.nameTH ?? ''})`
            }
        } else {
            displayResearcherName = val?.researcherFullname_en ?? '-'
            if (val?.researcherTypeInfo?.nameEN) {
                displayResearcherName += ` (${val?.researcherTypeInfo?.nameEN ?? ''})`
            }
        }
        return displayResearcherName
    }

    const getDisplaySubmittedDate = (val: ItemListType) => {
        let display = '-'
        if (val?.submittedDate) {
            display =
                translate.languageStore.currentLanguage === translate.languageKey.th
                    ? convertDateToFormatTH(val.submittedDate)
                    : convertDateToFormatEN(val.submittedDate)
        }
        return display
    }

    const conditionShowStatusInfo = (itm: any) => {
        if (isResearcher && itm?.submittedStatusInfo?.value === submittedStatus.waitingEditProject) {
            return translate.get('LABEL.RECEIVED_REVIEW_RESULT')
        }
        // else if (!isResearcher &&
        //     itm.isSubmittedReceiveDate &&
        //     itm?.submittedStatusInfo?.value === submittedStatus.directorAssigned //ต้องอยู่ใน submit status การรอเอกสารจากผู้วิจัยอย่างเดียว
        // ) {
        //     return translate.get('LABEL.COMMENT_DEADLINE_WAIT')
        // }

        if (
            itm?.projectStatusInfo?.value === constProjectStatus.closed || //ปิดโครงการ
            itm?.projectStatusInfo?.value === constProjectStatus.rejected || //ไม่อนุมัติ
            itm?.projectStatusInfo?.value === constProjectStatus.notScope || //ไม่เข้าข่าย
            itm?.projectStatusInfo?.value === constProjectStatus.terminate || //ยุติโครงการ
            itm?.projectStatusInfo?.value === constProjectStatus.withdraw //ถอนโครงการ
        ) {
            if (translate.languageStore.currentLanguage === translate.languageKey.th) {
                return itm?.projectStatusInfo?.nameTH
            } else {
                return itm?.projectStatusInfo?.nameEN
            }
        } else {
            if (isResearcher) {
                //กรณีเป็นนักวิจัย
                if (itm?.researcherSubmittedStatusInfo?.nameTH && itm?.researcherSubmittedStatusInfo?.nameEN) {
                    //มีข้อมูล researcherSubmittedStatusInfo
                    if (translate.languageStore.currentLanguage === translate.languageKey.th) {
                        return itm?.researcherSubmittedStatusInfo?.nameTH
                    } else {
                        return itm?.researcherSubmittedStatusInfo?.nameEN
                    }
                } else {
                    if (translate.languageStore.currentLanguage === translate.languageKey.th) {
                        return 'ร่าง'
                    } else {
                        return 'draft'
                    }
                }
            } else {
                //กรณีไม่ใช่นักวิจัย
                if (itm?.submittedStatusInfo?.nameTH && itm?.submittedStatusInfo?.nameEN) {
                    if (translate.languageStore.currentLanguage === translate.languageKey.th) {
                        return itm?.submittedStatusInfo?.nameTH
                    } else {
                        return itm?.submittedStatusInfo?.nameEN
                    }
                } else {
                    if (translate.languageStore.currentLanguage === translate.languageKey.th) {
                        return 'ร่าง'
                    } else {
                        return 'draft'
                    }
                }
            }
        }
    }

    const chkInProcessing = (itm?: GetProjectResultType) => {
        if (itm?.projectStatusInfo && itm?.projectStatusInfo.value === projectStatus.processing) {
            return true
        } else {
            return false
        }
    }

    const renderListElement = (itm?: any) => {
        const isProcessing = chkInProcessing(itm)
        const { statusTextColor, projectStatusBackgroundColor, submittedStatusColor } = checkStatusColor(itm)
        return (
            <Grid container>
                <Paper variant="outlined" style={{ padding: '20px', width: '100%', margin: '0px 0px 20px 5px' }}>
                    <Grid container spacing={2}>
                        <Grid container item xs={12} sm={2} alignItems="center">
                            <Paper variant="outlined" className={classes.paperProjectCode}>
                                <Typography noWrap variant={'body2'} style={{ fontWeight: 'bold' }}>
                                    {itm?.projectNumber ? itm?.projectNumber : '-'}
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Grid container alignItems="center">
                                <Grid item xs={12}>
                                    <Typography noWrap variant={'body2'} style={{ fontWeight: 'bold' }}>
                                        {getDisplayResearcherName(itm)}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} style={{ maxWidth: '100%' }}>
                                    <Typography noWrap variant={'body2'}>
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? itm?.projectName_th || '-'
                                            : itm?.projectName_en || '-'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container item xs={12} sm={3} alignItems="center">
                            <Grid item xs={12}>
                                <Typography variant={'body2'} style={{ fontWeight: 'bold' }}>
                                    {translate.languageStore.currentLanguage === translate.languageKey.th
                                        ? itm?.submitTypeInfo?.nameTH || '-'
                                        : itm?.submitTypeInfo?.nameEN || '-'}
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography noWrap variant={'body2'}>
                                    {`${translate.get('LABEL.SUBMITTED_DATE')} ${getDisplaySubmittedDate(itm)}`}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid container item xs={12} sm={2} alignItems="center">
                            <Paper
                                variant="outlined"
                                className={classes.paperProjectStatus}
                                style={{
                                    background: isProcessing
                                        ? `${submittedStatusColor}`
                                        : `${projectStatusBackgroundColor}`,
                                    color: `${statusTextColor}`,
                                }}
                            >
                                <Typography noWrap variant={'body2'}>
                                    {conditionShowStatusInfo(itm)}
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        )
    }

    return renderListElement(projectData)
}

//Controller
const AdminEditCtrl = (props: EditFormHeaderCtrlPropsType) => {
    const {} = props
    // const useEditFormHeaderModel = useEditFormHeader()
    // return <AdminEditView {...useEditFormHeaderModel} {...props} />
    return <AdminEditView {...props} />
}

export default AdminEditCtrl

const useStyles = makeStyles((theme) => ({
    spacingButton: {
        marginBottom: '10px',
    },
    paper: {
        width: '100%',
        height: 128,
        padding: 20,
    },
    titleFont: {
        color: '#BDBDBD',
    },
    contentFont: {
        fontWeight: 'bold',
    },
    paperProjectCode: {
        padding: '10px',
        background: '#f3f3f3',
        width: '120px',
        textAlign: 'center',
    },
    paperProjectStatus: {
        padding: '10px',

        // width: '150px',
        textAlign: 'center',
        borderRadius: '20px',
    },
}))
